var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('base-dialog', {
    on: {
      "show": _vm.setVScrollTarget
    },
    model: {
      value: _vm.isVisible,
      callback: function callback($$v) {
        _vm.isVisible = $$v;
      },
      expression: "isVisible"
    }
  }, [_c('dialog-template', {
    ref: "dialogTemplate"
  }, [_c('template', {
    slot: "title"
  }, [_vm._v(" " + _vm._s(_vm.$t('partners.choosing')) + " ")]), _c('virtual-scroll', {
    attrs: {
      "slot": "content",
      "options": _vm.partnersList,
      "wrapper": _vm.vscrollTarget,
      "height": 90
    },
    slot: "content",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var option = _ref.option,
            index = _ref.index;
        return [_c('div', {
          key: index,
          class: _vm.$style.project
        }, [_c('toggle-panel', {
          attrs: {
            "title": option.name
          },
          on: {
            "click": function click($event) {
              return _vm.handleChangeByIdx(index);
            }
          },
          model: {
            value: option.value,
            callback: function callback($$v) {
              _vm.$set(option, "value", $$v);
            },
            expression: "option.value"
          }
        }, [_c('project-logo', {
          attrs: {
            "slot": "icon",
            "project": option
          },
          slot: "icon"
        })], 1)], 1)];
      }
    }])
  }), _c('simple-button', {
    attrs: {
      "slot": "submit",
      "variant": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    },
    slot: "submit"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.save')) + " ")]), _c('simple-button', {
    attrs: {
      "slot": "cancel",
      "variant": "transparent"
    },
    on: {
      "click": _vm.handleClose
    },
    slot: "cancel"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }